import React from 'react';

import BoitageTransaction from '../../components/Analyzing/BoitageTransaction';

function BoitageTransactionView() {
  return (
    <BoitageTransaction />
  );
}

export default BoitageTransactionView;


